import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus, Loader2 } from 'lucide-react';

const CreateCodeDialog = ({ open, onOpenChange, code, setCode, onSubmit, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button className="btn-primary" size="sm" data-testid="create-code-btn">
        <Plus className="w-4 h-4 mr-1" /> Create Code
      </Button>
    </DialogTrigger>
    <DialogContent className="surface-card">
      <DialogHeader>
        <DialogTitle>Create Promo Code</DialogTitle>
        <DialogDescription>Generate a new promo code for subscription access</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 mt-2">
        <div className="space-y-2">
          <Label>Code (leave empty for auto-generated)</Label>
          <Input placeholder="e.g., WELCOME2026" value={code.code} onChange={(e) => setCode({ ...code, code: e.target.value.toUpperCase() })} data-testid="new-code-input" />
        </div>
        <div className="space-y-2">
          <Label>Plan</Label>
          <Select value={code.plan} onValueChange={(v) => setCode({ ...code, plan: v })}>
            <SelectTrigger data-testid="new-code-plan"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="basic">Basic</SelectItem>
              <SelectItem value="basic_plus">Basic Plus</SelectItem>
              <SelectItem value="premium">Coach Supported</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Max Uses (leave empty for unlimited)</Label>
          <Input type="number" placeholder="e.g., 100" value={code.max_uses} onChange={(e) => setCode({ ...code, max_uses: e.target.value })} data-testid="new-code-uses" />
        </div>
        <Button className="w-full btn-primary" onClick={onSubmit} disabled={loading} data-testid="submit-code-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : null}
          Create Code
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CreateCodeDialog;
